import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ClassListLayer from "../components/ClassListLayer";

const ClassListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Asset Class' />

        {/* BlankPageLayer */}
        <ClassListLayer />
      </MasterLayout>
    </>
  );
};

export default ClassListPage;